export const MODULE_NAME = 'sso';
